import TopBar from "./components/TopBar";
import HeroSection from "./components/HeroSection";
import NewsTicker from "./components/NewsTicker";
import TrendingIndex from "./components/TrendingIndex";
import FeaturedFlow from "./components/FeaturedFlow";
import TimelineSection from "./components/TimelineSection";
import OpinionSection from "./components/OpinionSection";
import CommentFeed from "./components/CommentFeed";
import CollectionSection from "./components/CollectionSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <TopBar />
      <main className="w-full">
        <HeroSection />
        <NewsTicker />
        <TrendingIndex />
        <FeaturedFlow />
        <TimelineSection />
        <OpinionSection />
        <CommentFeed />
        <CollectionSection />
      </main>
      <SiteFooter />
    </div>
  );
}